<template>
  <div class="role">
    <!-- 按钮 -->
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false: true" icon="el-icon-edit" @click="changeBox('edit')">编辑</el-button>
      <el-button  icon="el-icon-edit" @click="changeBox('create')">创建角色</el-button>
      <el-button :disabled="selectRow.length>=1?false: true" icon="el-icon-delete" @click="deleteRole()">删除</el-button>
    </div>
    <!-- 数据表格 -->
    <div class="table allDataTableBox">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border max-height="550" style="width: 99.9%">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip align="center"
          v-for="(item,i) in baseInfo"  :key="i"
          :prop="item.key" :label="item.value">
        </el-table-column>
      </el-table>
      <paging :pagesData="paging_data" @set_page_number='get_page_number'></paging>
    </div>
    <!-- 动态框 -->
    <el-dialog :visible.sync="centerDialogVisible" width="500px" :model="false" center :close-on-click-modal="false">
      <span slot="title" style="font-size:16px;">
        <span style="color:#409EFF;"><i class="el-icon-s-promotion"></i></span>角色信息
      </span>
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="125px">
        <el-form-item label="角色名称：" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="为角色分配权限：">
          <div class="power-box">
            <div class="power-right">
              <el-tree 
                :data="powerData" 
                show-checkbox 
                node-key="id" 
                ref="tree" 
                :props="defaultProps" 
                :default-checked-keys="checkedPower"></el-tree>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { powerData } from "@/publicData/powerData";
import mixins from '@/Mixins/mixin_3g48.js'
export default {
  mixins:[mixins],
  data() {
    return {
      paging_data: {//分页信息，分别为：当前页码，一页放多少条数据，查询到的数据总条数
        currentPage:1,
        pageSize:40,
        total:0,
      },
      rules:{//动态框验证规则
        name:[{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      },
      centerDialogVisible:false,//动态框默认不显示
      page:1,

      iscreat:false,//判断打开弹框，是否是创建角色
      editForm:{},//表单对象
      tableData:[],//拿到的所有角色数据
      selectRow:[],//选中的数据
      baseInfo:[//表头信息
        { key: 'name', value: '角色名称' },
      ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      checkedPower:[],//选中用户拥有权限的数组
      powerData:powerData,
      powerDataCopy:powerData,//备份,切换用户到管理员时,将之赋给遍历的powerData
    }
  },
  methods:{
    //获取角色数据列表
    getData(data){
      let userId = this.userInfo.id
      if (!data){
        data = {pageNumer:1,userId}
      }
      console.log(data)
      this.$api.getRole(data).then(res=> {
        if (res.data.status === 0) {
          let _r = JSON.parse(res.data.data)
          this.$data.paging_data.total = res.data.size
          this.tableData = _r;
          console.log("拿到渲染到表格的数据",this.tableData)
        } else {
          this._status(res.data)
        }
      })
    },
    //显示弹框
    changeBox(str){
      this.centerDialogVisible = true
      this.checkedPower = []
      console.log(this.checkedPower)
      str == 'edit' ? this.iscreat = false:""
      str == 'create' ? this.iscreat = true:""
      if (this.iscreat){//创建角色，将弹框里的内容清空
        this.editForm = {}
      } else {//编辑角色，将编辑的角色信息回显
        this.editForm = JSON.parse(JSON.stringify(this.selectRow[0]))
        this.checkedPower = JSON.parse(JSON.stringify(this.selectRow[0].privilegesList))
      }
      this.$nextTick(() => {//等待dom元素加载完成之后，再为树形控件给默认值
        this.$refs.tree.setCheckedKeys(this.checkedPower)
      });
    },
    //提交数据
    submit(){
      if (this.iscreat){//创建角色
        let resquestData = JSON.parse(JSON.stringify(this.editForm))
        resquestData.privilegesList=this.$refs.tree.getCheckedKeys().filter(o => o.indexOf("Lose") == -1)
        resquestData.userId = this.userInfo.id
        console.log(resquestData)
        this.$api.createRole(resquestData).then(res=>{
          if (res.data.status === 0){
            this.$message.success('创建成功！')
            this.getData()
            this.centerDialogVisible = false
          } else {
            this._status(res.data)
          }
        })
      } else {//编辑角色
        let resquestData = {}
        resquestData.privilegesList = this.$refs.tree.getCheckedKeys().filter(o => o.indexOf("Lose") == -1)
        resquestData.privilegesList.toString() == this.selectRow[0].privilegesList.toString() ? delete resquestData.privilegesList : ""
        this.editForm.name == this.selectRow[0].name ? "" : resquestData.name = this.editForm.name
        if (JSON.stringify(resquestData) != "{}"){
          resquestData.id = this.selectRow[0].id
          this.$api.editRole(resquestData).then(res=>{
            if (res.data.status === 0){
              this.$message.success('修改成功！')
              this.centerDialogVisible = false
              this.getData()
            } else {
              this._status(res.data)
            }
          })
        } else {
          this.$message.info('您未修改任何内容！')
        }
      }
    },
    //删除数据
    deleteRole(){
      let ids = this.selectRow.map(i => i.id)
      let userId = this.userInfo.id
      this.selectRow.length === 0  
        ? this.$message.error('请至少勾选一条数据') 
        : this.$confirm('确认删除数据?','提示',{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
            console.log(ids)
            this.$api.deleteRole(ids).then(res => {
              if (res.data.status === 0 ){
                this.$message.success('删除成功!')
                this.paging_data.total = this.paging_data.total - ids.length
                if (this.paging_data.total % this.paging_data.pageSize == 0){//把当前页的所有数据都删除时，需要更换页码
                  if (this.paging_data.currentPage > 1){
                    this.paging_data.currentPage--
                  } else {
                    this.paging_data.currentPage = 1
                  }
                }
                let pagedata = {pageNumer:this.paging_data.currentPage,userId}
                this.getData(pagedata)
              } else {
                this._status(res.data)
              }
            })
          }).catch(() => { this.$message.info('已取消删除') })
    },
    //点击数据前面的单选框，触发函数，val为选中的数据组成的数组
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      this.paging_data.currentPage = pageNumer
      this.getData(pageNumer)
    },
    setPowerArr() {//根据登录账号的权限,来限制哪些权限不可选,在角色分配和权限设置里面被调用
      let dataArr = JSON.parse(JSON.stringify(this.powerData))
      if (!this.userInfo.admin) {
        //删除用户没有的权限
        dataArr.forEach(x1 => {
          x1.children.forEach(x2 => {
            if (x2.children) {
              x2.children.forEach(x3 => {
                let arr2 = x2.children.filter(obj => this.userInfo.privilegesList.indexOf(obj.id) !== -1)
                x2.children = arr2
              })
              let arr = x1.children.filter(obj => obj.children.length !== 0)
              x1.children = arr
            } else {
              let arr1 = x1.children.filter(obj => this.userInfo.privilegesList.indexOf(obj.id) !== -1)
              x1.children = arr1
            }
          })
          let arr4 = dataArr.filter(obj => obj.children.length !== 0)
          dataArr = arr4
        })

        this.powerData = dataArr
      } else {
        this.powerData = JSON.parse(JSON.stringify(this.powerDataCopy))
      }
    },
  },
  created() {
    this.getData()
    this.setPowerArr()
  },
}
</script>
<style lang='scss' scoped>
/* @import url(); 引入css类 */

</style>